import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class IsNumberService {
  /**
   * Checks if a value is a number
   * @param value The value to check
   * @returns true if the value is a number, false otherwise
   */
  static isNumber(value: unknown): boolean {
    return (
      typeof value === 'number' ||
      (value !== null &&
        typeof value === 'object' &&
        Object.prototype.toString.call(value) === '[object Number]')
    );
  }
}
